import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { testData } from '../helpers/tableDataHelper';
import InputWrapper from './common/InputWrapper';
import { toast } from 'react-toastify';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SpinnerBlock from './common/SpinnerBlock';


const Wrapper = styled('div')`
  width: 1000px;
  min-height: 100vh;
  background: white;
  margin: 0 auto;
  padding: 20px;
  padding-top: 40px;

  .table-item {
    border-top: 1px solid #E4E4E4;
  }  
  .table-item__head--th {
    background: #F1F5F7;
    position: relative;
  }
  .table-item__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    height: 60px;
    cursor: pointer;
    
    &--hover {
      background: #F1F5F7;
    }
    
    & > div {
      display: flex;
      gap: 10px;    
      align-items: center;
    }
  }
  
  .table-item__id-column {
    width: 100px;
    position: relative;
    
    .fe-copy {
      padding: 10px;
      margin: -10px;
      position: absolute;
      left: -25px; 
      top: 3px;
      cursor: pointer;
    }
    
  }
  .table-item__title-wrapper {
    display: flex;
    flex-direction: column;
  }
  .table-item__loading {
    position: absolute; 
    height: 100vh; 
    left: 0; right: 0;
    top: 0;
    margin: 0 auto;
    background: rgba(255,255,255, .6);
    z-index: 1;
    
    .spinner-border {
      top: 10%;    
    }
  }
`
const TitleWrapper = styled('div')`
  padding-left: ${props => props.depth * 20}px;
  
  .table-item__title {
    font-weight: ${props => 700 - (props.depth * 100)};
    margin: 0;
  }
`

const TableItem = React.memo(({id, title, children, depth=0}) => {
  const [hover, setHover] = useState(null);
  const [open, setOpen] = useState(false);

  const subCategoriesCount = children?.length;
  return (
    <div className={'table-item'}>
      <div
        className={`table-item__head ${hover ? 'table-item__head--hover' : ''}`}
        onClick={() => setOpen(prev => !prev)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <TitleWrapper depth={depth}>
          <div style={{width: '10px'}}>
            {
              subCategoriesCount ? (
                <i className={`${open ? `fe-chevron-up` : `fe-chevron-down`} mr-1`} />
              ) : null
            }
          </div>
          <div className={'table-item__title-wrapper'}>
            <p className={'table-item__title'}>{title}</p>
            {subCategoriesCount ? (
              <span style={{fontSize: '12px'}}>
                {subCategoriesCount} подкатегорий(-ия)
              </span>
            ) : null}
          </div>
        </TitleWrapper>
        <span className={'table-item__id-column'} onClick={(e) => {e.stopPropagation();}}>
          {
            hover ? (
              <CopyToClipboard
                text={id}
                onCopy={() => {
                  toast.info('id категории скопировано');
                }}
              >
                <i className="fe-copy"/>
              </CopyToClipboard>
            ) : null
          }
          {id}
        </span>
      </div>
      {open && children?.length ? (
        <div className={'table-item__children'}>
          {
            children.map(item => (
              <TableItem key={item.id} depth={depth+1} {...item} />
            ))
          }
        </div>
      ) : null}
    </div>
  )
});

const JsonTestTable = (props) => {
  const categories = testData.categories;

  const [loading, setLoading] = useState(false);
  const [categoriesState, setCategoriesState] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setCategoriesState(categories);
  }, [])

  const findElement = async (items, accumItems) => {
    items.forEach(item => {
      const itemTitleLowerCase = item.title.toLowerCase();
      if (
        item.id.startsWith(searchValue) ||
        itemTitleLowerCase.startsWith(searchValue)
      ) {
        accumItems.push(item);
        return
      }

      if (item.children) {
        findElement(item.children, accumItems);
      }
    })
    return accumItems
  }

  const filterValue = async () => {
    if (!searchValue) {
      setCategoriesState(categories);
      return
    }
    setLoading(true);

    let accumItems = [];
    setTimeout(() => {
      findElement(categories, accumItems);
      setCategoriesState(accumItems);
      setLoading(false);
    }, 0);
  }

  return (
    <Wrapper>
      <div
        className="form-group"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            filterValue();
          }
        }}
      >
        <InputWrapper
          type="text"
          label="Поиск"
          id="search"
          icon={'fe-search'}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value?.toLowerCase());
          }}
          placeholder="Введите название или id"
        />
      </div>
      <div>
        <div className={'table-item__head table-item__head--th'}>
          <span>Категория/Подкатегория</span>
          <span className={'table-item__id-column'}>ID</span>
        </div>
        <div style={{position: 'relative'}}>
          {
            loading ? (
              <div className={'table-item__loading'}>
                <SpinnerBlock show={true} />
              </div>
            ) : null
          }
          {
            categoriesState.map(item => (
              <TableItem key={item.id} {...item} />
            ))
          }
          {
            !categoriesState.length ? (
              <h3 style={{textAlign: 'center', marginTop: '20px'}}>Не найдено ни одной категории</h3>
            ) : null
          }
        </div>
      </div>
    </Wrapper>
  );
}

export default JsonTestTable;
